module.exports = __webpack_public_path__ + "img/medgate-logo.994b1cb8.png";